import React from "react";
import { PageHeader } from "antd";
import { MyBreadcrumb } from "utils";
import IspForm from "./form";
export default function IspCreate() {
  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Utility Providers", path: "/utility-providers" },
          { label: "Create", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="Create"
        subTitle=""
      >
        <IspForm />
      </PageHeader>
    </div>
  );
}
